import { render, staticRenderFns } from "./LiquidationColumns.vue?vue&type=template&id=a1ae15da&scoped=true"
import script from "./LiquidationColumns.vue?vue&type=script&lang=js"
export * from "./LiquidationColumns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1ae15da",
  null
  
)

export default component.exports